'use strict';

import React from 'react';
import flux from 'utils/flux';
import linkifyHtml from 'linkifyjs/html';

var WatermarkModal = React.createClass({
    displayName: 'WatermarkModal',

    propTypes: {
        media: React.PropTypes.object
    },

    componentDidMount() {
        const { watermarkTimeout } = flux.getStore('app').getState().config.toJS();
        this._timeout && clearTimeout( this._timeout );
        this._timeout = setTimeout( this.closeModal, watermarkTimeout || 30000 );
    },

    componentWillUnmount() {
        clearTimeout( this._timeout );
    },

    closeModal() {
        flux.getActions('modals').closeModals();
    },

    render() {
        var media = this.props.media.toJS();
        var items = typeof media === 'array' ? media.filter( item => item.requires_watermark ) : null;

        return(
            <div>
                <h3 className="watermark__title">{flux.t('watermark_title')}</h3>
                <h4 className="watermark__subtitle">{flux.t('watermark_subtitle')}</h4>
                <p className="watermark__copy" dangerouslySetInnerHTML={{__html: linkifyHtml( flux.t('watermark_copy') )}} />
                {/*items.length &&
                    <ul className="watermark__list">
                        {items.slice( 0, 2 ).map( ( item, ix ) => {
                            return (
                                <li key={ix} className="watermark__item">
                                    <div className="watermark__figure">
                                        {!isEmpty(item.thumbnails) && <div className="watermark__image"><img src={item.thumbnails.thumb.src} width={item.thumbnails.thumb.width} height={item.thumbnails.thumb.height} /></div>}
                                    </div>
                                    <div className="watermark__details">
                                        <div className="watermark__assetname">{item.title}</div>
                                        <div className="watermark__action">{flux.t('watermark_action')}</div>
                                        <div className="progressbar" />
                                    </div>
                                </li>
                            )
                        })}
                    </ul>*/}
                {/*items.length > 2 && <div className="watermark__additional">{( items.length - 2 === 1 ? '\u2026plus {count} asset.' : '\u2026plus {count} assets.' ).replace( '{count}', items.length - 2 )}</div>*/}
                {/*<button className="btn btn-border watermark__closemodal" onClick={this.closeModal}>{flux.t('watermark_dismiss')}</button>*/}
            </div>
        );
    }
});

module.exports = WatermarkModal;



// WEBPACK FOOTER //
// ./app/components/modals/watermarkModal.jsx